import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Grid, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import TableChartIcon from '@mui/icons-material/TableChart';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import { brand } from '../getTheme/getTheme';
import { GeographyPreviewModal } from '../Dashboard/GeographyPreviewModal';

export const UserNeedMenu = () => {
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const navigate = useNavigate();

    const menuOptions = [
        {
            icon: <SmartToyIcon sx={{ fontSize: 36, color: hoveredIndex === 1 ? brand[200] : '#424242' }} />,
            title: 'Learn about a company',
            description: 'Chat with deepAnalysis, an AI equities research team',
            action: () => navigate('/deepanalysis/app'),
        },
        {
            icon: <ShowChartIcon sx={{ fontSize: 36, color: hoveredIndex === 2 ? brand[200] : '#424242' }} />,
            title: 'Deep-dive into filings data',
            description: 'Dig into timeseries and table data for a ticker',
            action: () => navigate('/deepkpi/app'),
        },
        {
            icon: <TableChartIcon sx={{ fontSize: 36, color: hoveredIndex === 4 ? brand[200] : '#424242' }} />,
            title: 'Pull data for an Excel model',
            description: 'Get the Excel add-in',
            action: () => window.open('https://appsource.microsoft.com/en-us/product/office/WA200007695?tab=Overview', '_blank'),
        },
    ];

    const isTouchDevice = () => 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    const MenuCard = styled(Box)(({ theme }) => ({
        background: 'linear-gradient(135deg, rgba(76, 168, 175, 0.1) 0%, rgba(13, 141, 246, 0.1) 100%)',
        border: '1px solid #424242',
        borderRadius: theme.shape.borderRadius * 2,
        px: 2,
        py: 1.5,
        cursor: 'pointer',
        transition: 'background 0.2s, transform 0.2s',
        backgroundColor: 'background.paper',
        width: '100%',
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        '&:hover': {
            background: 'linear-gradient(135deg, rgba(76, 155, 175, 0.18) 0%, rgba(33, 150, 243, 0.18) 100%)',
            transform: 'translateY(-4px)',
        },
        '@media (hover: none) and (pointer: coarse)': {
            '&:hover': {
                background: 'linear-gradient(135deg, rgba(76, 168, 175, 0.1) 0%, rgba(13, 141, 246, 0.1) 100%)',
                transform: 'none',
            },
        },
    }));

    return (
        <Box sx={{ minHeight: '70vh', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', position: 'fixed', top: '50px', left: 0, right: 0 }}>
            <Typography variant="h5" sx={{ color: 'white', mb: 3, textAlign: 'center' }}>
                What do you need to do?
            </Typography>
            <Grid container spacing={2} direction="column" justifyContent="center" alignItems="center" maxWidth={500}>
                {menuOptions.map((option, idx) => (
                    <Grid item xs={12} key={idx} sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                        <MenuCard
                            onClick={option.action}
                            sx={{ width: '100%', mx: 1 }}
                            onMouseEnter={() => !isTouchDevice() && setHoveredIndex(idx)}
                            onMouseLeave={() => !isTouchDevice() && setHoveredIndex(null)}
                            onTouchStart={() => isTouchDevice() && option.action()}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: 56, mr: { xs: 0.5, lg: 2 }, ml: { xs: 1, lg: 2 }, height: '100%' }}>
                                {option.icon}
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, m: 1 }}>
                                <Typography variant="subtitle1" fontWeight="bold" sx={{ color: brand[200], mb: 0 }}>
                                    {option.title}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {option.description}
                                </Typography>
                            </Box>
                        </MenuCard>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export const Launchpad = () => {
    const geography = process.env.REACT_APP_GEO?.toLowerCase() || 'us';

    return (
        <>
            <GeographyPreviewModal geography={geography} />
            <UserNeedMenu />
        </>
    );
};

export default Launchpad;
